import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { EditComponent }  from '../table/cell-components/actions/edit.component';
import { FranchiseModel } from './typings/franchise';
import { Table }          from '../table/types/table';

@Component({
  selector   : 'wor-franchises-settings',
  template: require('./franchises.settings.component.html')
})
export class FranchisesSettingsComponent {
  @Input() franchises: Array<FranchiseModel>;

  tableSettings: Table = {
    columns: [
      {
        field : 'name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
        }
      },
      {
        field : 'stock_number_range',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.STOCK_NO_RANGE')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: franchise => this.select(franchise)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_FRANCHISES_GROUPS_FOUND')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false,
    },
  };

  constructor (
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  select ( franchise : any ) : void {
    this.router.stateService.go('app.franchise', {
      id: franchise.id || franchise.row.id
    });
  }
}
